import { render, staticRenderFns } from "./WorkflowTransitionActionsDrawerList.vue?vue&type=template&id=8fa68516&"
import script from "./WorkflowTransitionActionsDrawerList.vue?vue&type=script&lang=ts&"
export * from "./WorkflowTransitionActionsDrawerList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports